var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center py-2"},[(_vm.miniVariant)?_c('img',{attrs:{"src":require('@/assets/min-logo.jpg'),"alt":"logo","width":"60"}}):_c('img',{attrs:{"src":require('@/assets/logo.jpg'),"alt":"logo","width":"100"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }